import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import '../styles/ElectricityMeter.css';

const deviceInfo = [
  { device: 'EM1', description: '3 Phase electricity meter (3PEM)', location: 'Electrical box', status: 'On' },
];
const usageData = [
  { date: '29/10/24', usage: 20, cost: 5 },
  { date: '30/10/24', usage: 25, cost: 6 },
  { date: '31/10/24', usage: 30, cost: 7 },
  { date: '01/11/24', usage: 35, cost: 8 },
  { date: '02/11/24', usage: 40, cost: 10 },
  { date: '03/11/24', usage: 38, cost: 9 },
  { date: '04/11/24', usage: 32, cost: 8 },
];

const ElectricityMeter = () => (
  <div className="electricitymeter-page">
    <h1>Electricity Meters</h1>
    <table>
      <thead>
        <tr>
          <th>Device</th>
          <th>Device Description</th>
          <th>Location</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {deviceInfo.map((d, idx) => (
          <tr key={idx}>
            <td>{d.device}</td>
            <td>{d.description}</td>
            <td>{d.location}</td>
            <td style={{ color: d.status === 'On' ? 'green' : 'red' }}>{d.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div className="electricitymeter-charts-row">
      <div className="electricitymeter-chart-block">
        <h3>Electricity Usage</h3>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={usageData}>
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="usage" fill="#ff9800" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="electricitymeter-chart-block">
        <h3>Cost</h3>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={usageData}>
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="cost" fill="#4caf50" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
    <div className="circuit-status-block">
      <button className="circuit-btn open">Valve is open</button>
    </div>
  </div>
);

export default ElectricityMeter; 